import { Check, Loader2 } from "lucide-react";
import { useTranslation } from "../i18n";

// Replaces per-panel Save buttons on auto-saving settings: "Saving..." while
// changes are pending or in flight, "Saved" once the panel is clean.
const SaveStatus = ({ dirty, saving }: { dirty: boolean; saving: boolean }) => {
    const { t } = useTranslation();
    const busy = dirty || saving;
    return (
        <span
            role="status"
            style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12, color: "var(--color-text-muted, #6b7280)" }}
        >
            {busy ? <Loader2 size={13} className="dispatch-admin-spin" /> : <Check size={13} color="#16a34a" />}
            {busy ? t("saving") : t("saved")}
        </span>
    );
};

export default SaveStatus;
